import React from 'react'

const MentalHeathCaseStudies = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5 sm:px-6 py-28 bg-bgDefault text-white overflow-x-hidden">
        <div className='container w-full max-w-full xl:mx-auto xl:max-w-screen-xl'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-8 w-full min-w-0'>
                <div className='min-w-0 max-w-full'>
                    <h2 className="text-[26px] leading-[34px] sm:text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 break-words max-w-full ">
                    Empowering Mental Health Professionals
                    </h2>
                     <div className="flex flex-wrap gap-2 mt-2 mb-6">
                        <span
                            className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                        >
                            Java
                        </span>
                        
                    </div>
                     <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto break-words max-w-full lg:px-0">
                     We partnered with a leading psychiatric clinic to revolutionize their mental healthcare delivery through
                              comprehensive digital transformation. Our secure, HIPAA-compliant platform successfully streamlined patient
                              management, session documentation, prescription workflows, and teleconsultation services, resulting in 45%
                              faster appointment scheduling, 60% improvement in clinical documentation accuracy, and 50% increase in
                              patient engagement. The solution now serves thousands of patients monthly with 99.9% uptime, establishing
                              new standards for digital mental healthcare delivery.
                        </p>

                </div>
                <div className='min-w-0 max-w-full'>
                <img src='/case_studies/title-banner/mentor-app-title-banner.png' className='w-full h-auto max-w-full' alt='Mental Health Platform'></img>
                </div>
            </div>
        </div>
    </section>
    )
}

export default MentalHeathCaseStudies